import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <Compass className="h-10 w-10 text-muted-foreground" strokeWidth={1.5} />
      <h1 className="text-lg font-semibold">Page not found</h1>
      <p className="text-sm text-muted-foreground">This page does not exist (anymore).</p>
      <Button asChild variant="outline" size="sm">
        <Link to="/explore">Back to Explore</Link>
      </Button>
    </div>
  );
}
